import PropTypes from "prop-types";
import cs from "classnames";

import { CTABlock } from "@lululemon/dsp-ecom-pattern-library";
import StoreInfoCard from "../store-info-card/store-info-card";
import content from "../../../content/content";
import { StoreList } from "../../../types";
import { useRegionalize } from "@lululemon/mwa-i18n";

import styles from "./list.module.scss";

const listContent = content.components.storeLocator.list;

const List = ({
  className,
  storeList,
  showAllStoresBtn,
  publicConfig,
  selectThisStore,
  onStoreSelected
}) => {
  const { regionalizeLink } = useRegionalize();

  const regionalizedLink = regionalizeLink(
    `${window.location.origin}/stores/all-lululemon-stores`
  );

  return (
    <div className={cs(styles.listContainer, className)}>
      <div className={styles.cardListingContainer}>
        {storeList.map((store) => {
          return (
            <StoreInfoCard
              storeId={store.id}
              key={store.id + store.fullAddress}
              distance={store.distance}
              fullAddress={store.fullAddress}
              hours={store.hours}
              message={store.message}
              specialHours={store.specialHours}
              storeName={store.name}
              storeSlug={store.slug}
              storeType={store.storeType}
              storeStatus={store.storeStatus}
              publicConfig={publicConfig}
              selectThisStore={selectThisStore}
              onStoreSelected={onStoreSelected}
              experientialStoreData={store.experientialStoreData}
            />
          );
        })}
      </div>
      {showAllStoresBtn && (
        <CTABlock
          href={regionalizedLink}
          heading={listContent.showAllStoresLabel}
        />
      )}
    </div>
  );
};

List.propTypes = {
  className: PropTypes.string,
  storeList: StoreList.type,
  showAllStoresBtn: PropTypes.bool,
  selectThisStore: PropTypes.bool,
  onStoreSelected: PropTypes.func,
  publicConfig: PropTypes.shape({
    googleMapsSearchDomain: PropTypes.string,
    googleMapsApiKey: PropTypes.string,
    nav: PropTypes.shape({
      apiHost: PropTypes.string,
      apiHostBasePath: PropTypes.string
    })
  }).isRequired
};

List.defaultProps = {
  className: "",
  storeList: StoreList.defaults,
  showAllStoresBtn: false,
  selectThisStore: false,
  onStoreSelected: () => {}
};

export default List;
